import { CONTRACTS_INBOX } from '../../constants/actions';
import { apiActionCreator } from '../helpers';
import { contracts } from '../../services/api';
import { LOCATION_CHANGE, push } from 'react-router-redux';
import { CONTRACT_PATH, ROOT_PATH } from '../../constants/routes';
import { FORBIDDEN_CODE } from '../../constants/http.codes';
import { forbiddenAction } from '../error.handling';
import { downloadPDF } from '../../lib/html.utils';
import { CONTRACT_TYPES } from '../../constants/settings';

export function fetch(pagination, type) {
    return async dispatch => {
        dispatch({ type: CONTRACTS_INBOX.FETCH_START });
        dispatch({
            type: CONTRACTS_INBOX.UPDATE,
            field: 'page',
            value: pagination.page
        });
        dispatch({
            type: CONTRACTS_INBOX.UPDATE,
            field: 'pageSize',
            value: pagination.pageSize
        });
        await apiActionCreator(
            dispatch,
            () => contracts.getInbox(pagination, type),
            response => {
                dispatch({
                    type: CONTRACTS_INBOX.FETCH_OK,
                    ...response
                });
            },
            {
                [FORBIDDEN_CODE]: () => {
                    dispatch(push(ROOT_PATH));
                    dispatch(forbiddenAction());
                }
            }
        );
    };
}

export function openContract(c) {
    return push(CONTRACT_PATH.replace(':id', c.id));
}



// WEBPACK FOOTER //
// ./src/actions/contracts/inbox.js